import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { ITableRow, TableRow, TableRowPropertyValues } from "./Table";
import { NAMESPACE } from "./_Namespace";

export type TableRowEntitySearchPropertyValues =
    TableRowPropertyValues
    & {
    };

export type TableRowEntitySearchProperties = {
    [name in keyof TableRowEntitySearchPropertyValues]: Property<TableRowEntitySearchPropertyValues[name]>
};

export interface ITableRowEntitySearch extends ITableRow, TableRowEntitySearchProperties
{
}

export class TableRowEntitySearch extends TableRow implements ITableRowEntitySearch
{
    public static override classNamespace = NAMESPACE + "TableRowEntitySearch";
    public static override className = "TableRowEntitySearch";

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TableRowEntitySearchPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-table-row-entity-search");
    }

    // #endregion

    // #region Overrides

    protected override _refreshFromDataSource()
    {
        super._refreshFromDataSource();

        const
            dataSource = this.dataSource.get();

        if (!dataSource)
            return;

        if (dataSource.propertyValueByPathGet("deletedGuid"))
            this.addCssClass("rad-control-table-row-soft-deleted");
        else
            this.removeCssClass("rad-control-table-row-soft-deleted");
    }

    // #endregion
}

